import * as type from '../actions/types';

const initialState = {
  fetching: false,
  data: {
    offerlessEnabled: false,
    blacklisted: false,
  },
  error: false,
  errorMessage: '',
  success: false,
  shouldFetch: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_OFFERLESS_CONFIG_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
        shouldFetch: false,
      };
    case type.FETCH_OFFERLESS_CONFIG_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: action.payload?.data,
        error: false,
        errorMessage: '',
        success: true,
        shouldFetch: false,
      };
    case type.FETCH_OFFERLESS_CONFIG_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    case type.UPDATE_OFFERLESS_CONFIG_PENDING:
      return {
        ...state,
        fetching: true,
        error: false,
        errorMessage: '',
        shouldFetch: false,
      };
    case type.UPDATE_OFFERLESS_CONFIG_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: {
          ...state.data,
          offerlessEnabled: true, // Assume this is true if response was success
        },
        error: false,
        errorMessage: '',
        success: true,
        shouldFetch: false,
      };
    case type.UPDATE_OFFERLESS_CONFIG_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};
